import {saveAs} from 'file-saver';
import {InjectionToken} from '@angular/core';

export const fileSaverToken = new InjectionToken<string>('fileSaverToken');

export const FileSaverProvider = {provide: fileSaverToken, useValue: saveAs};
